import { validateConnection } from "@electro-planner/domain";
import type { IsValidConnection } from "@xyflow/react";

export type NodeTerminalLookup = (
  nodeId: string,
  handleId: string,
) => { kind: "phase" | "neutral" | "earth" | "control" | "signal"; label: string } | null;

/**
 * Hård blockering = returnera false. React Flow renderar då röd "forbidden"-cursor.
 * Warnings tillåter vi (returnerar true) — UI markerar ledaren röd efteråt.
 *
 * React Flow skickar in antingen en Connection (drag pågår) eller en Edge
 * (existerande koppling valideras om) — båda har source/target/*Handle.
 */
export function createIsValidConnection(
  lookup: NodeTerminalLookup,
): IsValidConnection {
  return (edgeOrConn) => {
    const source = edgeOrConn.source;
    const target = edgeOrConn.target;
    const sourceHandle = edgeOrConn.sourceHandle ?? null;
    const targetHandle = edgeOrConn.targetHandle ?? null;
    if (!source || !target || !sourceHandle || !targetHandle) return false;
    if (source === target) return false;
    const from = lookup(source, sourceHandle);
    const to = lookup(target, targetHandle);
    if (!from || !to) return false;
    const v = validateConnection(from, to);
    return v.severity !== "blocked";
  };
}
